export const endsWith = (str, suffix) => {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
};

export const removeUrlParameter = (url, parameter) => {
    const urlParts = url.split('?');
    if (urlParts.length >= 2) {
        const urlBase = urlParts.shift();
        let queryString = urlParts.join('?');
        const prefix = encodeURIComponent(parameter) + '=';
        const parts = queryString.split(/[&;]/g);
        for (let i = parts.length; i-- > 0;) {
            if (parts[i].lastIndexOf(prefix, 0) !== -1) {
                parts.splice(i, 1);
            }
        }
        url = urlBase + '?' + parts.join('&');
    }
    return url;
};

export const removeUrlParameters = (excludeParameters, url) => {
    let returnUrl = '';
    excludeParameters.forEach((value) => {
        if (returnUrl !== '') {
            returnUrl = removeUrlParameter(returnUrl, value);
        } else {
            returnUrl = removeUrlParameter(url, value);
        }
    });
    if (endsWith(returnUrl, "?") || endsWith(returnUrl, "&")) {
        returnUrl = returnUrl.slice(0, -1);
    }
    return returnUrl;
};